import { Texto } from '@gravitate-js/excalibrr'
import type { ICellRendererParams } from 'ag-grid-community'
import { Popover } from 'antd'
import React from 'react'

export function NotesRenderer({ value }: ICellRendererParams) {
  const [showPopover, setShowPopover] = React.useState(false)

  function handleShowPopover() {
    setShowPopover(true)
  }
  function handleHidePopover() {
    setShowPopover(false)
  }

  if (!value) return 'N/A'
  return (
    <div
      style={styles.container}
      onMouseOver={handleShowPopover}
      onFocus={handleShowPopover}
      onMouseOut={handleHidePopover}
      onBlur={handleHidePopover}
    >
      <Popover visible={showPopover} content={value} overlayStyle={styles.popover}>
        <Texto style={styles.text}>{value}</Texto>
      </Popover>
    </div>
  )
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  popover: {
    width: '250px',
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
